import React, { useEffect, useState, useMemo, Suspense, lazy } from 'react';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet-async';
import { NavLink } from 'react-router-dom';
import {
  Divider as MuiDivider,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Stack,
  ThemeProvider,
  Typography,
  useTheme,
  TableCell,
} from '@mui/material';
import Box from '@mui/system/Box';
import spacing from '@mui/system/spacing';
import DataTable, {
  statusMappingBackendToFrontend,
} from '../../components/DataTable';
import { useAuth } from '../../services/contexts/AuthContext';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import shadows from '@mui/material/styles/shadows';
import StepperPopup from '../../components/StepperPopup';
import MultipleParkingLotEdit from '../../components/multipleEditDialog/MultipleParkingLotEdit';
import { ArrowForward } from '@mui/icons-material';
import MultipleStatusEdit from '../../components/multipleEditDialog/MultipleStatusEdit';
import Feedback from '../../components/DataTable/Feedback';
import { createTheme } from '@mui/material/styles';
import CreateStation from './components/StationForm';
import { useTranslation } from 'react-i18next';
import api from '../../Middleware/api/api';
import { PAGE_SIZE } from '../../services/utils/units-constants';
import LogoLoader from '../../components/LogoLoader';
const Divider = styled(MuiDivider)(spacing);
const FailFeedback = lazy(() => import('../../components/DataTable/Feedback'));
import { format } from 'date-fns';

const dataTableTheme = () =>
  createTheme({
    components: {
      MuiList: {
        styleOverrides: {
          root: {
            maxHeight: 300,
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            '&[data-colindex="5"]': {
              '& > *': {
                justifyContent: 'center',
                textAlign: 'center',
              },
            },
            '&[data-colindex="1"]': {
              '& > *': {
                justifyContent: 'left',
                textAlign: 'left',
                paddingLeft: 12,
              },
            },
            '&[data-colindex="6"], &[data-colindex="7"]': {
              '& > *': {
                justifyContent: 'right',
                textAlign: 'right',
                paddingLeft: 12,
              },
            },
          },
        },
      },
      MUIDataTableBodyCell: {
        styleOverrides: {
          root: {
            '&[data-colindex="4"]': {
              '& > *': {
                justifyContent: 'center',
                textAlign: 'center',
                paddingRight: 10,
              },
            },
          },
        },
      },
    },
  });

export const mapStatus = (value, parkingLot, t) => {
  let renderStatus = '';
  if (value === 'connected_unavailable') {
    renderStatus = parkingLot
      ? statusMappingBackendToFrontend.connected_unavailable.withParkingLot
      : statusMappingBackendToFrontend.connected_unavailable.noParkingLot;
  } else if (value === 'idle') {
    renderStatus = t('LBLActive');
  } else if (value === 'removed') {
    renderStatus = t('connRemoved');
  } else renderStatus = value;
  return renderStatus;
};

function Stations() {
  const { t, i18n } = useTranslation();
  const { status } = useTheme();
  const { token } = useAuth();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState([]);
  const [payload, setPayload] = useState([]);
  const [submit, setSubmit] = useState(0);
  const [isStatusEditModalOpen, setIsStatusEditModalOpen] = useState(false);
  //const [isConnRemoveModal, setIsConnRemoveModal] = useState(false);
  const [statusDialogData, setStatusDialogData] = useState([]);
  const [parkingDialogData, setParkingDialogData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showFeedbackParking, setShowFeedbackParking] = useState(false);
  const [showFeedbackStatus, setShowFeedbackStatus] = useState(false);
  const [checkStatusChange, setCheckStatusChange] = useState(false);
  const [showErrorEmptyParkingEdit, setShowErrorEmptyParkingEdit] =
    useState(false);
  const [showNoRowSelected, setShowNoRowSelected] = useState(false);
  const [errorTitle, setErrorTitle] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE[0]);

  const [stationsData, setStationsData] = useState([]);
  const [showPasswdButton] = useState(false);
  const [rows, setRows] = useState([]);
  const [
    ButtonDownloadPasswdIsSubmitting,
    setButtonDownloadPasswdIsSubmitting,
  ] = useState(false);

  const [
    errorWhenExportingConnectorPasswd,
    setErrorWhenExportingConnectorPasswd,
  ] = useState(false);

  const [loading, setLoading] = useState(false);
  const [newFilters, setNewFilters] = useState([]);
  const [enterKeyboardButtonPressed, setEnterKeyboardButtonPressed] =
    useState(false);
  useEffect(() => {
    if (!isStatusEditModalOpen) setCheckStatusChange(false);
  }, [isStatusEditModalOpen]);

  const headCenterCellStyle = {
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    //fontWeight: 'bold',
  };
  const [wallboxInfo, setWallboxInfo] = useState([]);
  const [locations, setLocations] = useState([]);

  const [colsChangeAvailability, setColsChangeAvailability] = useState([]);
  //here
  const colsChangeAvailabilityNotRemoved = [
    {
      name: 'locationName',
      label: t('LBLLocation'),
    },
    {
      name: 'cpId',
      label: 'Station-ID',
    },
    {
      name: 'parkingLot',
      label: t('LBLParkingLotNum'),
    },
    {
      name: 'connectorStatus',
      label: t('LBLCHarginStationStatus'),
      type: 'select',
      selectConfig: {
        label: t('LBLCHarginStationStatus'),
        values: [
          {
            value: 'IDLE',
            label:
              i18n.language === 'de'
                ? statusMappingBackendToFrontend['idle']
                : 'Active',
          },
          {
            value: 'CONNECTED_UNAVAILABLE',
            label: mapStatus('connected_unavailable', ' ', t),
          },
        ],
      },
    },
  ];
  const colsChangeAvailabilityRemoved = [
    {
      name: 'locationName',
      label: t('LBLLocation'),
    },
    {
      name: 'cpId',
      label: 'Station-ID',
    },
    {
      name: 'parkingLot',
      label: t('LBLParkingLotNum'),
    },
    {
      name: 'connectorStatus',
      label: t('LBLCHarginStationStatus'),
      //type: 'remove_conn',
      type: 'select',
      selectConfig: {
        label: t('LBLCHarginStationStatus'),
        values: [
          {
            value: 'REMOVED',
            label: mapStatus('removed', ' ', t),
          },
        ],
      },
    },
  ];

  useEffect(() => {
    api.fetchLocationsForDropDown(token).then((response) => {
      if (response?.data?.data == null) {
        setLocations([]);
      } else {
        setLocations(response?.data?.data);
      }
    });

    api.fetchWallboxTypes(token).then((response) => {
      if (response?.data?.data == null) {
        setWallboxInfo([]);
      } else {
        setWallboxInfo(response?.data?.data);
      }
    });
  }, []);
  const [apiCallCount, setApiCallCount] = useState(0);
  const columns = [
    {
      name: 'connectorId',
      options: {
        display: false,
        filter: false,
        customBodyRender: (value) => {
          return value || <>-</>;
        },
      },
    },
    {
      name: 'cpId',
      label: t('Station-ID'),
      options: {
        filter: true,
        filterOptions: {
          fullWidth: true,
        },
        sort: false,
        customFilterListRender: (v) => t('Station-ID') + `: ${v}`,
        filterType: 'textField',
        customHeadRender: () => (
          <TableCell variant="head" sx={headCenterCellStyle}>
            {t('Station-ID')}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <Typography align="center">{value}</Typography>
        ),
      },
    },
    {
      name: 'connectorId',
      label: t('connectorId'),
      options: {
        filter: false,
        customHeadRender: () => (
          <TableCell variant="head" sx={headCenterCellStyle}>
            {t('connectorId')}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <Typography align="center">{value?.split('_')?.pop()}</Typography>
        ),
      },
    },
    {
      name: 'locationName',
      label: t('LBLLocation'),
      options: {
        filter: false,
        customHeadRender: () => (
          <TableCell variant="head" sx={headCenterCellStyle}>
            {t('LBLLocation')}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <Typography align="center">{value}</Typography>
        ),
      },
    },
    {
      name: 'locationIds',
      label: t('LBLLocation'),
      options: {
        display: false,
        filter: true,
        sort: false,
        filterType: 'multiselect',
        filterOptions: {
          fullWidth: true,
          names: locations.map((x) => x.locationId + ' : ' + x.locationName),
        },
        customFilterListRender: (v) => t('LBLLocation') + `: ${v}`,
      },
    },
    {
      name: 'addressParkingLot',
      label: t('LBLParkingLot'),
      options: {
        filter: true,
        filterOptions: {
          fullWidth: true,
        },
        sort: false,
        customFilterListRender: (v) => t('LBLParkingLot') + `: ${v}`,
        filterType: 'textField',
        customHeadRender: () => (
          <TableCell variant="head" sx={headCenterCellStyle}>
            {t('LBLParkingLot')}
          </TableCell>
        ),
        customBodyRender: (addressParkingLot) => {
          return (
            <>
              <Typography align="center">{addressParkingLot}</Typography>
            </>
          );
        },
      },
    },
    {
      name: 'wallboxModel',
      label: t('LBLModelOfCharginStation'),
      options: {
        filter: false,
        customHeadRender: () => (
          <TableCell variant="head" sx={headCenterCellStyle}>
            {t('LBLModelOfCharginStation')}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <Typography align="center">{value}</Typography>
        ),
      },
    },
    {
      name: 'wallboxModels',
      label: t('LBLModelOfCharginStation'),
      options: {
        display: false,
        filter: true,
        sort: false,
        filterType: 'multiselect',
        filterOptions: {
          fullWidth: true,
          names: wallboxInfo,
        },
        customFilterListRender: (v) => t('LBLModelOfCharginStation') + `: ${v}`,
      },
    },
    {
      name: 'connectorStatusMapping',
      label: t('LBLCHarginStationStatus'),
      options: {
        filter: false,
        customHeadRender: () => (
          <TableCell variant="head" sx={headCenterCellStyle}>
            {t('LBLCHarginStationStatus')}
          </TableCell>
        ),
        customBodyRender: (value) => {
          if (!value) return null;
          return (
            <Typography
              align="center"
              sx={{ color: value.colourCode, fontWeight: 500 }}
            >
              {t(value.enumName)}
            </Typography>
          );
        },
      },
    },

    {
      name: 'edit',
      label: ' ',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value) => {
          return (
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <IconButton onClick={handleClickIconMenu(value)}>
                  <EditIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorIconButton}
                  key={value}
                  open={openElem === value}
                  onClose={handleCloseIconMenu}
                  MenuListProps={{
                    'aria-labelledby': 'edit-selected',
                  }}
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <MenuItem
                    key={value}
                    onClick={() => {
                      setParkingDialogData(
                        rows
                          .filter((row) => value === row.connectorId)
                          .map((row) => ({
                            ...row,
                            parkingLot: row.address.parkingLot,
                          }))
                      );
                      handleCloseIconMenu();
                    }}
                  >
                    <Typography align="center" sx={{ width: '100%' }}>
                      {t('LBLParkplatzhinterlegen')}
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setStatusDialogData(
                        rows
                          .filter((row) => value === row.connectorId)
                          .map((row) => ({
                            ...row,
                            parkingLot: row.address.parkingLot,
                          }))
                      );
                      handleCloseIconMenu();
                    }}
                  >
                    {t('ChangechargingStatus')}
                  </MenuItem>
                </Menu>
              </Grid>
              <Grid item xs={8}>
                <Button
                  component={NavLink}
                  to={`/stationen/${value}/`}
                  variant="text"
                >
                  {t('LBLDetails')}
                </Button>
              </Grid>
            </Grid>
          );
        },
      },
    },
  ];
  useEffect(() => {
    setSelected(selectedRows.map((index) => rows[index].connectorId));
  }, [selectedRows]);

  useEffect(() => {
    if (parkingDialogData.length > 0) {
      if (
        parkingDialogData.filter((row) => row.connectorStatus === 'INACTIVE')
          .length > 0
      ) {
        setErrorTitle(t('LBLWrongSelection'));
        setError(
          <>
            {t('cswithstatus')}{' '}
            <span style={{ color: status.inaktiv }}>{t('LBLInactive')}</span>{' '}
            {t('cantedit')}.
          </>
        );
        setParkingDialogData([]);
      } else setIsEditModalOpen(true);
    }
  }, [parkingDialogData]);

  useEffect(() => {
    if (statusDialogData?.length > 0) {
      if (
        statusDialogData?.filter(
          (row) => row?.connectorStatus === 'REMOVED' 
          || (row.connectorStatus === 'CONNECTED_UNAVAILABLE' && !row.parkingLot)
        ).length === statusDialogData?.length
      ) {
        setErrorTitle(t('notpossible'));
        setError(
          <>
            {t('csstatus')}{' '}
            <span style={{ color: status.standby }}>Standby</span>{' '}
            {i18n.language === 'en' ? 'or ' : 'oder '}
            <span style={{ color: status.aktiv }}>{t('LBLActive')}</span>{' '}
            {t('tobeedited')}
          </>
        );
        setStatusDialogData([]);
      } else if (
        statusDialogData?.filter(
          (row) =>
            row?.connectorStatus === 'OFFLINE' ||
            row?.connectorStatus === 'INACTIVE'
        )?.length === statusDialogData?.length
      ) {
        setColsChangeAvailability(colsChangeAvailabilityRemoved);
        setIsStatusEditModalOpen(true);
      } else if (
        statusDialogData?.filter(
          (row) =>
            row?.connectorStatus === 'OCCUPIED_UNCHARGED' ||
            row?.connectorStatus === 'OCCUPIED_CHARGING'
        )?.length === statusDialogData?.length
      ) {
        setErrorTitle('Ladestation im Betrieb');
        setError(
          <>
            {t('LBLChastationInuse')}: <br />{' '}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <ul>
                {statusDialogData
                  ?.filter(
                    (row) =>
                      row?.connectorStatus === 'OCCUPIED_UNCHARGED' ||
                      row?.connectorStatus === 'OCCUPIED_CHARGING'
                  )
                  .map((item) => (
                    <li key={item?.cpId}>{item?.cpId}</li>
                  ))}
              </ul>
            </Box>
            {t('csnotcahn')}
          </>
        );
        setStatusDialogData([]);
      } else if (
        statusDialogData?.filter(
          (row) =>
            !(
              row?.connectorStatus === 'REMOVED' ||
              (row.connectorStatus === 'CONNECTED_UNAVAILABLE' && !row.parkingLot) ||
              row?.connectorStatus === 'OFFLINE' ||
              row?.connectorStatus === 'INACTIVE' ||
              row?.connectorStatus === 'OCCUPIED_UNCHARGED' ||
              row?.connectorStatus === 'OCCUPIED_CHARGING'
            )
        ).length === statusDialogData?.length
      ) {
        setColsChangeAvailability(colsChangeAvailabilityNotRemoved);
        setIsStatusEditModalOpen(true);
      } else {
        setErrorTitle(t('notpossible'));
        setError(
          <>
            {t('csstatus')}{' '}
            <span style={{ color: status.standby }}>Standby</span>{' '}
            {i18n.language === 'en' ? 'or ' : 'oder '}
            <span style={{ color: status.aktiv }}>{t('LBLActive')}</span>{' '}
            {t('tobeedited')}
          </>
        );
        setStatusDialogData([]);
      }
    }
  }, [statusDialogData]);

  const closeErrorFeedback = () => setError('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    fetchStationsList();
  };
  const [openElem, setOpenElem] = React.useState(null);
  const [anchorIconButton, setAnchorIconButton] = useState(null);
  const [showDuplicateModel, setShowDuplicateModel] = useState(false);
  const [showDuplicateModelData, setShowDuplicateModelData] = useState('');
  const [showDuplicateModelTitle, setShowDuplicateModelTitle] = useState('');

  const handleClickIconMenu = (elem) => (event) => {
    setAnchorIconButton(event.currentTarget);
    setOpenElem(elem);
  };
  const handleCloseIconMenu = () => {
    setOpenElem(null);
    setAnchorIconButton(null);
  };
  const triggerMultipleStatusEdit = () => {
    setAnchorEl(null);
    if (selected?.length > 0) {
      setStatusDialogData(
        rows
          .filter((row) => selected?.includes(row?.connectorId))
          .map((row) => ({ ...row, parkingLot: row?.address?.parkingLot }))
      );
    } else {
      setShowNoRowSelected(true);
    }
  };
  const triggerMultipleParkingEdit = () => {
    setAnchorEl(null);
    if (selected?.length > 0) {
      setParkingDialogData(
        rows
          .filter((row) => selected?.includes(row?.connectorId))
          .map((row) => ({ ...row, parkingLot: row?.address?.parkingLot }))
      );
    } else {
      setShowNoRowSelected(true);
    }
  };
  const triggerDownloadConnectorPassword = () => {
    setAnchorEl(null);
    if (selected.length > 0) {
      const connectorList = rows?.filter((row) => selected?.includes(row?.connectorId)).map((item) => item?.connectorId);
      exportConnectorPasswords(connectorList?.toString());
    } else {
      setShowNoRowSelected(true);
    }
  };

  const exportConnectorPasswords = (connectorList) => {
    setLoading(true);
    api
      .exportConnectorPasswords(connectorList, token)
      .then((response) => {
        const filename = response?.headers['filename'];
        setButtonDownloadPasswdIsSubmitting(false);
        setLoading(false);
        setSelectedRows([]);
        if (response?.status == 200) {
          if (response?.data) {
            const url = window.URL.createObjectURL(new Blob([response?.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        } else {
          setErrorWhenExportingConnectorPasswd(true);
        }
      })
      .catch((reason) => {
        setButtonDownloadPasswdIsSubmitting(false);
        setLoading(false);
        setErrorWhenExportingConnectorPasswd(true);
      });
  };

  const [successfullPrakingLotUpdated, setSuccessfullPrakingLotUpdated] =
    useState(0);

  const buildUrlParams = useMemo(() => {
    const urlParams = new URLSearchParams();
    if (newFilters && typeof newFilters === 'object') {
      Object.entries(newFilters).forEach(([key, values]) => {
        if (Array.isArray(values) && values.length > 0) {
          let formattedValues = values;
          if (key === 'locationIds') {
            formattedValues = values.map((val) => val.split(':')[0].trim());
          }
          urlParams.set(key, formattedValues.join(','));
        }
      });
    }
    urlParams.set('page', currentPage);
    urlParams.set('size', pageSize);
    return urlParams;
  }, [newFilters, currentPage, pageSize]);

  useEffect(() => {
    if (apiCallCount > 0) {
      fetchStationsList();
    }
  }, [apiCallCount]);

  useEffect(async () => {
    fetchStationsList();
  }, [currentPage, pageSize]);

  const fetchStationsList = () => {
    fetchConnectors(buildUrlParams);
  };

  const resetFilterApi = () => {
    const resetParams = new URLSearchParams();
    resetParams.set('page', '0');
    resetParams.set('size', pageSize.toString());
    fetchConnectors(resetParams);
  };

  const fetchConnectors = async (urlParams) => {
    setStationsData([]);
    setSelectedRows([]);
    setLoading(true);
    try {
      api.fetchCharginStations(token, urlParams).then(
        (response) => {
          if (response?.data?.data == null) {
            setLoading(false);
            setStationsData([]);
          } else {
            setLoading(false);
            setTotalRecords(response?.data?.data?.totalNumberOfRecords);
            setStationsData(response?.data?.data?.response);
          }
        },
        () => {
          setLoading(false);
          setStationsData([]);
        }
      );
    } catch (exception) {
      setLoading(false);
      setStationsData([]);
    }
  };

  useEffect(() => {
    if (stationsData) {
      let itemListinitial = [];
      stationsData.forEach((elem) => {
        itemListinitial.push(elem);
      });
      setRows(itemListinitial);
    }
  }, [successfullPrakingLotUpdated, showFeedbackStatus, stationsData]);

  const handleChangeError = (input) => {
    setShowDuplicateModelData(input.detail);
    setShowDuplicateModelTitle(input.title);
    setShowDuplicateModel(true);
  };
  const closeDuplicateError = () => {
    setShowDuplicateModel(false);
    setSubmit(0);
    fetchStationsList();
  };
  useEffect(() => {
    if (enterKeyboardButtonPressed) {
      handleApply();
    }
  }, [enterKeyboardButtonPressed]);

  const handleEnterKey = React.useCallback((e) => {
    console.log('e?.key value ', e?.key);
    if (e?.key === 'Enter') {
      e.preventDefault();
      setEnterKeyboardButtonPressed(true);
    }
  }, []);
  const handleApply = () => {
    if (currentPage > 0) {
      setCurrentPage(0);
    } else {
      fetchStationsList();
    }
    setEnterKeyboardButtonPressed(false);
  };

  const closedModalEvent = () => {
    setApiCallCount(1);
  };
  const openedModalEvent = () => {
    setApiCallCount(0);
  };

  return (
    <React.Fragment>
      <LogoLoader loading={loading} />
      <Helmet title="Invoices" />

      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            {t('LBLCharginStations')}
          </Typography>
        </Grid>
        <Grid item>
          <CreateStation
            handleCloseModal={closedModalEvent}
            handleOpenModal={openedModalEvent}
            locations={locations}
            wallboxTypes={wallboxInfo}
          />
        </Grid>
      </Grid>

      <Divider my={6} />
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Box width="100%">
            <Stack alignItems="flex-end" spacing={8} position="relative">
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  onClick={handleClick}
                  id="edit-selected"
                  sx={{
                    // minWidth: 154,
                    position: 'absolute',
                    boxShadow: shadows[3],
                    top: ({ spacing }) => spacing(12),
                    left: ({ spacing }) => spacing(3),
                    zIndex: ({ zIndex }) => zIndex.appBar,
                  }}
                >
                  {t('LBLEditMulti')}
                </Button>

                <Button
                  variant="contained"
                  onClick={triggerDownloadConnectorPassword}
                  sx={{
                    position: 'absolute',
                    boxShadow: shadows[3],
                    top: ({ spacing }) => spacing(12),
                    left: ({ spacing }) => spacing(42),
                    zIndex: ({ zIndex }) => zIndex.appBar,
                    display: showPasswdButton ? 'block' : 'none',
                  }}
                  disabled={
                    ButtonDownloadPasswdIsSubmitting || selected.length == 0
                  }
                >
                  {t('LBL_Export_Connector_Passwd')}
                </Button>
              </Stack>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'edit-selected',
                }}
                sx={{
                  textAlign: 'center',
                }}
              >
                <MenuItem onClick={triggerMultipleParkingEdit}>
                  {' '}
                  <Typography align="center" sx={{ width: '100%' }}>
                    {t('LBLParkplatzhinterlegen')}
                  </Typography>{' '}
                </MenuItem>
                <MenuItem onClick={triggerMultipleStatusEdit}>
                  {t('ChangechargingStatus')}
                </MenuItem>
              </Menu>
              <Paper
                variant="outlined"
                sx={{
                  width: '100%',
                  '& .MuiTypography-h6': {
                    opacity: 0,
                  },
                }}
              >
                <ThemeProvider
                  theme={(appTheme) => ({
                    ...appTheme,
                    components: {
                      ...appTheme.components,
                      ...dataTableTheme(appTheme).components,
                    },
                  })}
                >
                  <DataTable
                    title={t('LBLCharginStations')}
                    data={
                      rows.map((row) => ({
                        ...row,
                        edit: row.connectorId,
                        addressParkingLot: row?.address?.parkingLot,
                      })) || []
                    }
                    columns={columns}
                    options={{
                      textLabels: {
                        body: {
                          noMatch: !rows
                            ? t('getcharginstation')
                            : t('nocharginstation'),
                        },
                      },
                      onRowSelectionChange: (_props, allRowsSelected) => {
                        setSelectedRows(
                          allRowsSelected.map(({ index }) => index)
                        );
                      },
                      rowsSelected: selectedRows,
                      filter: true,
                      selectableRows: true,
                      currentPage: currentPage,
                      totalRecords: totalRecords,
                      customFilterDialogFooter: () => {
                        return (
                          <div style={{ margin: '1rem', textAlign: 'center' }}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleApply}
                            >
                              {t('BTNSubmit')}
                            </Button>
                          </div>
                        );
                      },
                      onFilterDialogOpen: () => {
                        window.addEventListener('keydown', handleEnterKey);
                      },
                      onFilterDialogClose: () => {
                        window.removeEventListener('keydown', handleEnterKey);
                      },
                      onTableChange: (action, tableState) => {
                        if (action === 'filterChange') {
                          const newFilters = {};
                          tableState.filterList.forEach((filter, index) => {
                            if (filter.length > 0) {
                              newFilters[tableState.columns[index].name] =
                                filter;
                            }
                          });
                          setNewFilters(newFilters);
                        } else if (action === 'resetFilters') {
                          setNewFilters([]);
                          resetFilterApi();
                        }
                      },
                    }}
                    getData={(seletedPageSize, currentPageVal) => {
                      setCurrentPage(currentPageVal);
                      setPageSize(seletedPageSize);
                    }}
                  ></DataTable>
                </ThemeProvider>
              </Paper>
            </Stack>
            <Suspense fallback={<div />}>
              <StepperPopup
                isOpen={Boolean(isEditModalOpen)}
                setIsOpen={setIsEditModalOpen}
                title={t('LBLParkplatzhinterlegen')}
                steps={[
                  {
                    label: t('EnterINfo'),
                    component: (
                      <MultipleParkingLotEdit
                        data={parkingDialogData}
                        payload={payload}
                        setPayload={setPayload}
                        isReadOnly={false}
                        showEmptyFieldError={showErrorEmptyParkingEdit}
                        setShowFeedbackError={handleChangeError}
                      />
                    ),
                    nextAction: {
                      label: t('LBLFurther'),
                      icon: <ArrowForward />,
                      action: () => {
                        setShowErrorEmptyParkingEdit(true);
                      },
                      canNext:
                        payload.filter(
                          (row) =>
                            !row.parkingLotNumber ||
                            row.parkingLotNumber?.length > 5
                        ).length <= 0,
                    },
                  },
                  {
                    label: t('confirmInfo'),
                    component: (
                      <MultipleParkingLotEdit
                        data={parkingDialogData}
                        payload={payload}
                        setPayload={setPayload}
                        isReadOnly={true}
                        submit={submit}
                        setShowFeedback={setShowFeedbackParking}
                        setShowFeedbackError={handleChangeError}
                      />
                    ),
                    nextAction: {
                      label: t('LBLSave'),
                      icon: <></>,
                      action: () => {
                        setSubmit((prevState) => prevState + 1);
                        setIsEditModalOpen(false);
                        setShowErrorEmptyParkingEdit(false);
                      },
                      canNext: false,
                    },
                  },
                ]}
              />
              <StepperPopup
                isOpen={Boolean(isStatusEditModalOpen)}
                setIsOpen={setIsStatusEditModalOpen}
                title={t('ChangechargingStatus')}
                steps={[
                  {
                    label: t('LBLChangeEnter'),
                    component: (
                      <MultipleStatusEdit
                        data={statusDialogData}
                        cols={colsChangeAvailability}
                        payload={payload}
                        setPayload={setPayload}
                        isReadOnly={false}
                        checkStatusChange={checkStatusChange}
                      />
                    ),
                    nextAction: {
                      label: t('LBLFurther'),
                      icon: <ArrowForward />,
                      action: () => {
                        setCheckStatusChange(true);
                      },
                      canNext:
                        // isConnRemoveModal ||
                        !payload.filter((value) => value?.changed === false)
                          .length > 0,
                    },
                  },
                  {
                    label: t('LBLConfirmChanges'),
                    component: (
                      <MultipleStatusEdit
                        data={statusDialogData}
                        cols={colsChangeAvailability}
                        payload={payload}
                        setPayload={setPayload}
                        submit={submit}
                        isReadOnly={true}
                        setShowFeedback={setShowFeedbackStatus}
                      />
                    ),
                    nextAction: {
                      label: t('LBLSave'),
                      icon: <></>,
                      action: () => {
                        setSubmit((prev) => prev + 1);
                        setIsStatusEditModalOpen(false);
                        //setIsConnRemoveModal(false);
                      },
                      canNext: false,
                    },
                  },
                ]}
              />
              <FailFeedback
                open={errorWhenExportingConnectorPasswd}
                title={t('LBL_Export_Connector_Passwd_Title')}
                severity="warning"
                message={
                  <>
                    <Typography align="center">
                      {t('LBL_Export_Connector_Passwd_Body')}
                    </Typography>
                  </>
                }
                handleClose={() => {
                  setErrorWhenExportingConnectorPasswd(false);
                }}
              />

              <Feedback
                open={!!error}
                title={errorTitle}
                message={
                  <Typography variant="subtitle1" sx={{ width: 400, mx: 10 }}>
                    {error}
                  </Typography>
                }
                severity="warning"
                handleClose={closeErrorFeedback}
              />
              <Feedback
                open={showFeedbackParking}
                handleClose={() => {
                  setSuccessfullPrakingLotUpdated((prev) => prev + 1);
                  setShowFeedbackParking(false);
                  setSubmit(0);
                  fetchStationsList();
                }}
                message={t('ParkinglotUpdated')}
                title={t('lotNumberUpdated')}
              />
              <Feedback
                open={showNoRowSelected}
                handleClose={() => {
                  setShowNoRowSelected(false);
                }}
                severity="warning"
                message={
                  <Typography
                    variant="subtitle1"
                    fontWeight={400}
                    sx={{ width: 400, mx: 10 }}
                  >
                    {t('selectOnechstation')}
                  </Typography>
                }
              />
              <Feedback
                open={showDuplicateModel}
                title={showDuplicateModelTitle}
                message={
                  <Typography variant="subtitle1" sx={{ width: 400, mx: 10 }}>
                    {showDuplicateModelData}
                  </Typography>
                }
                severity="warning"
                handleClose={closeDuplicateError}
              />
              <Feedback
                open={showFeedbackStatus}
                handleClose={() => {
                  setShowFeedbackStatus(false);
                  setSubmit(0);
                  fetchStationsList();
                }}
                message={t('ParaCHarginst')}
                title={t('statussubmitted')}
              />
            </Suspense>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Stations;
